module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Welcome Back")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5217f208"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/callback.vue
// module id = 937
// module chunks = 1